<!--
트래킹검수 > 메인 컴포넌트
------------------------------------
-->
<template>
    <div class="uk-flex uk-flex-column uk-flex-between uk-flex-stretch uk-height-1-1">
        <!-- 상단헤더 영역 -->
        <layout-header
            :region-id="regionId"
            :scan-no="scanNo"
            :urgent-ship-in="urgentShipIn"
            :found-count="foundCount"
            :select-tracking="selectTracking"
        >
        </layout-header>


        <!-- 컨텐츠 영역 -->
        <div class="uk-height-1-1 uk-overflow-auto">

            <scan
                class=""
                ref="scan"
                :csrf-token="csrfToken"
                :region-id="regionId"
                :region-code="regionCode"

                v-on:update:scan="scanListener($event)"

                v-show="displayScan"
                :scan-no="scanNo"
                :has-not-found="hasNotFound"
                :ship-in="shipIn"
            >
            </scan>



            <urgent-ship-in
                ref="urgent"
                :urgent-ship-in="urgentShipIn"
            >
            </urgent-ship-in>


            <trackings
                v-show="displayTrackings"
                :trackings="trackings"
                :has-not-selected="hasNotSelected"
            >
            </trackings>



            <check
                v-show="displayCheck"
                ref="check"
                :csrf-token="csrfToken"
                :login-user-id="loginUserId"
                :region-id="regionId"
                :check-mode="checkMode"
                :scan-no="scanNo"
                :expensive-limit="expensiveLimit"
            >
            </check>



            <app-check-packing
                v-show="displayPacking"
                ref="packing"
                :csrf-token="csrfToken"
                :login-user-id="loginUserId"
                v-on:cancel="packingClose"

                :default-unit="defaultUnit"
            >
                <button
                    slot="done-button"
                    class="uk-button uk-button-black uk-button-large"
                    @click="packingClose"
                >
                    <i class="material-icons">play_circle_outline</i>
                    계속 검수하기
                </button>
            </app-check-packing>


            <app-check-nodata
                v-show="displayNodata"
                ref="nodata"

                :csrf-token="csrfToken"
                :region-id="regionId"
                :region-code="regionCode"

                @cancel="nodataCancel"
                @registerd="nodataRegisterd"
            >
            </app-check-nodata>


        </div>

        <!-- 하단푸터 영역-->
        <layout-footer
            :region-id="regionId"
            :login-user-name="loginUserName"
            :check-mode="checkMode"
            v-on:update:checkmode="checkmodeListener($event)"
        >
        </layout-footer>

    </div>
</template>

<script>
    export default {
        components: {
            'scan': require('./scan.vue').default,
            'trackings': require('./trackings.vue').default,
            'check': require('./check.vue').default,
            'layout-header': require('./layout-header.vue').default,
            'layout-footer': require('./layout-footer.vue').default,
            'urgent-ship-in': require('./urgent-ship-in.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 로그인 유저 ID
             **/
            loginUserId: {
                type: Number,
                default: null,
            },


            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },

            /**
             * 지역코드
             * (미국 커스텀때문에 추가됨)
             * 1 : 일본
             * 2 : 미국
             * 3 : 중국항공
             * 4 : 중국해상
             * 5 : 영국
             * 6 : 독일
             * 7 : 호주
             **/
            regionCode: {
                type: Number,
                default: null,
            },

            /**
             * 사용자명
             */
            loginUserName: {
                type: String,
                default: null,
            },

            /**
             * 고가상품 기준가격(현지 currency)
             **/
            expensiveLimit: {
              type: Number,
              default: 200,
            },

            /**
             * 사용단위 (기본값)
             * - kg : kg, cm 사용
             * - lb : lb(파운드), in(인치) 사용
             */
            defaultUnit: {
                type: String,
                default: 'kg',
            },


        },
        data: function () {
            /**
             * 검수모드 쿠키값
             */
            let $check_mode = Cookies.get('tracking-check-mode');
            if (! $check_mode) {
                $check_mode = 'normal';
            }

            // 노멀모드만 제공하기로함
            $check_mode = 'normal';


            //console.log($check_mode);

            return {

                /**
                 * (string) 표시화면
                 *  - scan
                 *  - trackings
                 *  - check
                 *  - packing
                 *  - nodata
                 */
                screen: 'scan',

                /**
                 * 스캔 번호
                 */
                scanNo: null,

                /**
                 * (object) 스캔번호에 대한 입고정보
                 */
                shipIn: null,

                /**
                 * (object) 스캔번호에 대한 긴급입고정보
                 *  - 위의 입고정보(shipIn)과 동일한 객체이지만,
                 *    긴급입고가 설정된 입고일때만 urgentShipIn에 할당된다.
                 */
                urgentShipIn: null,

                /**
                 * (array) 조회된 트래킹 내역
                 * [
                 *      {user_id, user_nick, tracking_no, total_prod_amount},
                 *      {},
                 *      .
                 *      .
                 *      .
                 * ]
                 */
                trackings: [],

                /**
                 * 현재 선택된 트래킹정보
                 * trackings 와 동일한 object 모델을 사용함
                 */
                selectTracking: null,

                /**
                 * (bool) 모드일반 옵션
                 *  - normal : 일반검수모드
                 *  - batch : 일괄검수모드
                 *  - batch2 : 일괄검수모드2
                 */
                checkMode: $check_mode,

            };
        },
        mounted: function () {
            /*
            document.addEventListener('vue:ready', () => {
                //this.$refs['scan'].scanForce('1Z917F070321417154'); //todo : 제거
                //this.$refs['scan'].scanForce('9400111899564837596252');
                //this.$refs['check'].listnePacking(1000135); // 2건 패킹
                this.$refs['check'].listnePacking(1000786); // 1건 패킹

                //this.$refs['scan'].scanForce('12345678'); // has-not-found
                //this.$refs['scan'].scanForce(''); // empty-input
            });
             */

        },
        computed: {
            /**
             * 조회된 트래킹 건수
             * @return int
             */
            foundCount: function () {
                return this.trackings.length;
            },

            /**
             * 트래킹 자료조회 실패
             * 경고표시
             *
             * @return bool
             **/
            hasNotFound: function () {

                return this.scanNo
                    && this.trackings.length === 0;
            },

            /**
             * 조회된 트래킹 내역은 있는데, 현재 선택된 트래킹이 없음
             * 경고표시
             *
             * @return bool
             **/
            hasNotSelected: function () {

                return (! this.selectTracking)
                    && this.trackings.length > 0;
            },

            /**
             * 스캔 화면 표시
             * @return bool
             */
            displayScan: function () {
                return this.screen === 'scan';
            },

            /**
             * 트래킹 선택 화면 표시
             * @return bool
             */
            displayTrackings: function () {
                return this.screen === 'trackings';
            },

            /**
             * 검수 화면 표시
             * @return bool
             */
            displayCheck: function () {
                return this.screen === 'check';
            },

            /**
             * 패킹 화면 표시
             * @return bool
             */
            displayPacking: function () {
                return this.screen === 'packing';
            },

            /**
             * 무자료등록 화면 표시
             * @return bool
             */
            displayNodata: function () {
                return this.screen === 'nodata';
            },

        },
        methods: {

            /**
             * 스캔 이벤트 리스너
             * @param scan (object)이벤트 전달값
             */
            scanListener: function (scan) {
                // 스캔 결과 저장
                this.scanNo = scan.scan_no;
                this.shipIn = scan.ship_in;
                this.urgentShipIn = null;
                this.trackings = scan.trackings;
                this.selectTracking = null;

                // 긴급입고여부
                if (this.shipIn && this.shipIn.urgent_type === 1) {
                    this.urgentShipIn = this.shipIn;
                }

                // 화면 선택
                if (Number.isInteger(scan.selected_index)) {
                    let tracking = this.trackings[scan.selected_index];

                    // 트래킹 선택
                    this.checkTracking(tracking);

                } else if (this.trackings.length > 0) {
                    // 선택된 트래킹은 없지만, 트래킹내역은 조회 성공
                    this.showTrackings();

                } else {
                    // 하나도 조회되지 않음
                    this.showScan();
                }

                // 긴급입고정보 표시
                if (this.urgentShipIn) {
                    this.showUrgentShipIn();
                }

            },

            /**
             * 검수레이아웃 변경 리스너
             * @param mode 선택된 검수레이아웃 모드
             */
            checkmodeListener: function (mode) {
                //console.log(mode);
                Cookies.set('tracking-check-mode', mode, { expires: 3650 });
                this.checkMode = mode;
            },



            /**
             * 긴급입고 정보를 확인
             **/
            showUrgentShipIn() {
                this.$refs.urgent.show();
            },


            /**
             * 패킹 취소 / 완료 리스너
             */
            packingClose: function () {
                if (this.selectTracking) {
                    this.checkInfoRefresh();
                } else {
                    this.showScan();
                }
            },

            /**
             * 무자료 취소  리스너
             */
            nodataCancel: function () {
                this.showScan();
            },

            /**
             * 무자료 등록완료  리스너
             */
            nodataRegisterd: function () {
                // 미국은 다시 검수페이지로 이동 (다음 부분무자료 등록을 위해서..)
                if (this.regionCode === 2) {
                    this.checkInfoRefresh();
                } else {
                    $.app.refresh();
                }

            },

            /**
             * 선택한 트래킹을 검수한다
             * @param tracking
             * @return void
             */
            checkTracking: function (tracking) {
                // 트래킹 저장
                this.selectTracking = tracking;

                // 트래킹화면 선택
                this.showCheck();

                // 트래킹정보 조회
                this.$refs.check.loadProds(tracking.tracking_no, tracking.user_id, null, tracking.scanned_no);
            },

            /**
             * 현재 검수화면의 정보를 갱신한다( 상품정보 갱신)
             * @return void
             */
            checkInfoRefresh: function () {
                // 트래킹화면 선택
                this.showCheck();

                // 트래킹정보 조회
                this.$refs.check.reload();
            },

            /**
             * 스캔화면으로 전환
             */
            showScan: function () {
                this.screen = 'scan';

                // 포커싱
                this.$nextTick(() => {
                    this.$refs.scan.focus();
                });

            },

            /**
             * 트래킹 선택화면으로 전환
             */
            showTrackings: function () {
                this.screen = 'trackings';
            } ,

            /**
             * 검수 화면으로 전환
             */
            showCheck: function () {
                this.screen = 'check';
            } ,

            /**
             * 패킹 화면으로 전환
             */
            showPacking: function (house_id) {
                this.screen = 'packing';
                this.$refs.packing.init(house_id);
            } ,

            /**
             * 무자료등록 화면으로 전환
             */
            showNodata: function () {
                this.screen = 'nodata';
                this.$refs.nodata.init(this.scanNo);
            } ,

            /**
             * 부분무자료등록 화면으로 전환
             */
            showNodataPart: function (tracking_no, user_id) {
                this.screen = 'nodata';
                this.$refs.nodata.init(tracking_no, user_id, '무자료(부분)');
            } ,
        },
    }
</script>

<style lang="scss" scoped>
</style>